<template>
  <div
    @click="!disabled && $emit('click')"
    :class="['navigation-item', { 'navigation-item--primary': primaryItem }]"
  >
    <div
      v-ripple="showRipple"
      :class="[
        {
          container: true,
          'container--active': active,
          'container--disabled': disabled,
        },
      ]"
    >
      <span class="white-line white-line--top" />

      <CSSVGIcon
        :iconName="icon"
        class="container__icon"
        data-test="navigation-item-icon"
      />

      <span
        data-test="navigation-item-text"
        v-text="text"
        class="container__text"
      />

      <span class="white-line white-line--bottom" />
    </div>
  </div>
</template>

<script>
import CSSVGIcon from '@/components/atoms/icons/CSSVGIcon.vue'

export default {
  name: 'NavigationItem',
  components: { CSSVGIcon },

  props: {
    icon: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },

    disabled: {
      type: Boolean,
    },

    active: {
      type: Boolean,
    },

    primaryItem: {
      type: Boolean,
    },
  },

  computed: {
    showRipple() {
      if (this.disabled || !this.primaryItem) {
        return false
      }

      if (this.active) {
        return true
      }

      return { class: 'white--text' }
    },
  },
}
</script>
